<style scoped type="text/css">
.lst-kix_fdrvb9dtqn26-6>li:before {
    content: "\0025cf   "
}

.lst-kix_fdrvb9dtqn26-7>li:before {
    content: "\0025cb   "
}

.lst-kix_fdrvb9dtqn26-8>li:before {
    content: "\0025a0   "
}

ul.lst-kix_fdrvb9dtqn26-5 {
    list-style-type: none
}

ul.lst-kix_fdrvb9dtqn26-6 {
    list-style-type: none
}

ul.lst-kix_fdrvb9dtqn26-3 {
    list-style-type: none
}

ul.lst-kix_fdrvb9dtqn26-4 {
    list-style-type: none
}

ul.lst-kix_387ssfg3ijxl-3 {
    list-style-type: none
}

ul.lst-kix_fdrvb9dtqn26-1 {
    list-style-type: none
}

ul.lst-kix_387ssfg3ijxl-2 {
    list-style-type: none
}

ul.lst-kix_fdrvb9dtqn26-2 {
    list-style-type: none
}

ul.lst-kix_387ssfg3ijxl-1 {
    list-style-type: none
}

ul.lst-kix_387ssfg3ijxl-0 {
    list-style-type: none
}

ul.lst-kix_fdrvb9dtqn26-0 {
    list-style-type: none
}

ul.lst-kix_387ssfg3ijxl-7 {
    list-style-type: none
}

ul.lst-kix_387ssfg3ijxl-6 {
    list-style-type: none
}

ul.lst-kix_387ssfg3ijxl-5 {
    list-style-type: none
}

ul.lst-kix_387ssfg3ijxl-4 {
    list-style-type: none
}

ul.lst-kix_387ssfg3ijxl-8 {
    list-style-type: none
}

.lst-kix_dgm8n7a3v4ec-8>li:before {
    content: "\0025a0   "
}

.lst-kix_dgm8n7a3v4ec-6>li:before {
    content: "\0025cf   "
}

.lst-kix_dgm8n7a3v4ec-5>li:before {
    content: "\0025a0   "
}

.lst-kix_dgm8n7a3v4ec-7>li:before {
    content: "\0025cb   "
}

.lst-kix_fdrvb9dtqn26-5>li:before {
    content: "\0025a0   "
}

ul.lst-kix_fdrvb9dtqn26-7 {
    list-style-type: none
}

.lst-kix_fdrvb9dtqn26-4>li:before {
    content: "\0025cb   "
}

ul.lst-kix_fdrvb9dtqn26-8 {
    list-style-type: none
}

.lst-kix_dgm8n7a3v4ec-2>li:before {
    content: "\0025a0   "
}

.lst-kix_387ssfg3ijxl-0>li:before {
    content: "\0025cf   "
}

.lst-kix_dgm8n7a3v4ec-1>li:before {
    content: "\0025cb   "
}

.lst-kix_dgm8n7a3v4ec-3>li:before {
    content: "\0025cf   "
}

.lst-kix_fdrvb9dtqn26-1>li:before {
    content: "\0025cb   "
}

.lst-kix_fdrvb9dtqn26-3>li:before {
    content: "\0025cf   "
}

.lst-kix_dgm8n7a3v4ec-4>li:before {
    content: "\0025cb   "
}

.lst-kix_dgm8n7a3v4ec-0>li:before {
    content: "\0025cf   "
}

.lst-kix_fdrvb9dtqn26-2>li:before {
    content: "\0025a0   "
}

.lst-kix_387ssfg3ijxl-2>li:before {
    content: "\0025a0   "
}

.lst-kix_387ssfg3ijxl-1>li:before {
    content: "\0025cb   "
}

.lst-kix_fdrvb9dtqn26-0>li:before {
    content: "\0025cf   "
}

.lst-kix_387ssfg3ijxl-7>li:before {
    content: "\0025cb   "
}

.lst-kix_387ssfg3ijxl-6>li:before {
    content: "\0025cf   "
}

.lst-kix_387ssfg3ijxl-8>li:before {
    content: "\0025a0   "
}

ul.lst-kix_dgm8n7a3v4ec-8 {
    list-style-type: none
}

ul.lst-kix_dgm8n7a3v4ec-7 {
    list-style-type: none
}

ul.lst-kix_dgm8n7a3v4ec-6 {
    list-style-type: none
}

ul.lst-kix_dgm8n7a3v4ec-5 {
    list-style-type: none
}

ul.lst-kix_dgm8n7a3v4ec-4 {
    list-style-type: none
}

.lst-kix_387ssfg3ijxl-3>li:before {
    content: "\0025cf   "
}

ul.lst-kix_dgm8n7a3v4ec-3 {
    list-style-type: none
}

ul.lst-kix_dgm8n7a3v4ec-2 {
    list-style-type: none
}

.lst-kix_387ssfg3ijxl-4>li:before {
    content: "\0025cb   "
}

ul.lst-kix_dgm8n7a3v4ec-1 {
    list-style-type: none
}

ul.lst-kix_dgm8n7a3v4ec-0 {
    list-style-type: none
}

.lst-kix_387ssfg3ijxl-5>li:before {
    content: "\0025a0   "
}

ol {
    margin: 0;
    padding: 0
}

table td,
table th {
    padding: 0
}

.c8 {
    border-right-style: solid;
    padding-top: 0pt;
    border-top-width: 0pt;
    border-right-width: 0pt;
    padding-left: 0pt;
    padding-bottom: 0pt;
    line-height: 1.15;
    border-left-width: 0pt;
    border-top-style: solid;
    background-color: #fcfcff;
    border-left-style: solid;
    border-bottom-width: 0pt;
    border-bottom-style: solid;
    orphans: 2;
    widows: 2;
    text-align: left;
    padding-right: 0pt
}

.c14 {
    border-right-style: solid;
    padding-top: 0pt;
    border-top-width: 0pt;
    border-right-width: 0pt;
    padding-left: 0pt;
    padding-bottom: 0pt;
    line-height: 1.0;
    border-left-width: 0pt;
    border-top-style: solid;
    margin-left: 7.9pt;
    border-left-style: solid;
    border-bottom-width: 0pt;
    border-bottom-style: solid;
    orphans: 2;
    widows: 2;
    text-align: left;
    padding-right: 0pt
}

.c17 {
    color: #434343;
    font-weight: 400;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 13pt;
    font-family: "Lato";
    font-style: normal
}

.c13 {
    color: #a829a2;
    font-weight: 400;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 16pt;
    font-family: "Lato";
    font-style: normal
}

.c2 {
    padding-top: 16pt;
    padding-bottom: 4pt;
    line-height: 1.0791666666666666;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left
}

.c0 {
    color: #434343;
    font-weight: 400;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 10pt;
    font-family: "Lato";
    font-style: normal
}

.c5 {
    padding-top: 18pt;
    padding-bottom: 6pt;
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left
}

.c25 {
    padding-top: 16pt;
    padding-bottom: 4pt;
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left
}

.c9 {
    padding-top: 0pt;
    padding-bottom: 8pt;
    line-height: 1.15;
    orphans: 2;
    widows: 2;
    text-align: right;
    margin-right: -37.5pt
}

.c3 {
    color: #a829a2;
    font-weight: 400;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 15pt;
    font-family: "Lato";
    font-style: normal
}

.c24 {
    color: #434343;
    font-weight: 400;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 11pt;
    font-family: "Lato";
    font-style: normal
}

.c12 {
    color: #434343;
    font-weight: 400;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 14pt;
    font-family: "Lato";
    font-style: normal
}

.c6 {
    color: #a829a2;
    font-weight: 700;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 19pt;
    font-family: "Lato";
    font-style: normal
}

.c16 {
    color: #660000;
    font-weight: 400;
    text-decoration: none;
    vertical-align: baseline;
    font-family: "Lato";
    font-style: normal
}

.c22 {
    color: #434343;
    font-weight: 400;
    text-decoration: none;
    vertical-align: baseline;
    font-family: "Lato";
    font-style: italic
}

.c4 {
    padding-top: 0pt;
    padding-bottom: 8pt;
    line-height: 1.15;
    orphans: 2;
    widows: 2;
    text-align: left
}

.c20 {
    color: #000000;
    font-weight: 400;
    text-decoration: none;
    vertical-align: baseline;
    font-family: "Arial";
    font-style: normal
}

.c23 {
    padding-top: 0pt;
    padding-bottom: 0pt;
    line-height: 1.15;
    orphans: 2;
    widows: 2;
    text-align: left
}

.c15 {
    color: #ffffff;
    text-decoration: none;
    vertical-align: baseline;
    font-size: 8pt;
    font-family: "Lato";
    font-style: normal
}

.c19 {
    text-decoration-skip-ink: none;
    -webkit-text-decoration-skip: none;
    color: #1155cc;
    text-decoration: underline
}

.c26 {
    font-size: 8pt;
    font-family: "Calibri";
    color: #000000;
    font-weight: 400
}

.c10 {
    background-color: #ffffff;
    max-width: 451.4pt;
    padding: 72pt 72pt 72pt 72pt
}

.c18 {
    font-size: 8pt;
    color: #ffffff
}

.c27 {
    color: inherit;
    text-decoration: inherit
}

.c21 {
    font-size: 13pt
}

.c11 {
    height: 11pt
}

.c1 {
    font-size: 10pt
}

.c28 {
    page-break-after: avoid
}

.c7 {
    font-weight: 700
}

.title {
    padding-top: 0pt;
    color: #a829a2;
    font-weight: 300;
    font-size: 32pt;
    padding-bottom: 8pt;
    font-family: "Lato";
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left
}

.subtitle {
    padding-top: 0pt;
    color: #666666;
    font-weight: 300;
    font-size: 15pt;
    padding-bottom: 16pt;
    font-family: "Lato";
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left
}

li {
    color: #434343;
    font-size: 11pt;
    font-family: "Lato"
}

p {
    margin: 0;
    color: #434343;
    font-size: 11pt;
    font-family: "Lato"
}

h1 {
    padding-top: 0pt;
    color: #a829a2;
    font-weight: 700;
    font-size: 20pt;
    padding-bottom: 8pt;
    font-family: "Lato";
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left
}

h2 {
    padding-top: 18pt;
    color: #a829a2;
    font-size: 16pt;
    padding-bottom: 6pt;
    font-family: "Lato";
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left
}

h3 {
    padding-top: 16pt;
    color: #434343;
    font-size: 14pt;
    padding-bottom: 4pt;
    font-family: "Lato";
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left
}

h4 {
    padding-top: 14pt;
    color: #666666;
    font-size: 12pt;
    padding-bottom: 4pt;
    font-family: "Lato";
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left
}

h5 {
    padding-top: 12pt;
    color: #666666;
    font-size: 11pt;
    padding-bottom: 4pt;
    font-family: "Lato";
    line-height: 1.15;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
    text-align: left
}

h6 {
    padding-top: 12pt;
    color: #666666;
    font-size: 11pt;
    padding-bottom: 4pt;
    font-family: "Lato";
    line-height: 1.15;
    page-break-after: avoid;
    font-style: italic;
    orphans: 2;
    widows: 2;
    text-align: left
}
</style>
<template>
    <div>
        <div class="display-2" v-if="$root.isSmallScreen">{{ $translate('Zoezi Developer Portal') }}</div>
        <div class="display-4" v-if="!$root.isSmallScreen">{{ $translate('Zoezi Developer Portal') }}</div>
        <div class="headline">{{ $translate('Log in or register new account') }}</div>
        <v-row>
            <v-col cols=12 md=4>
                <v-container class="px-0" fluid>
                    <v-radio-group v-model="mode">
                        <v-radio :label="$translate('Log in')" value="login"></v-radio>
                        <v-radio :label="$translate('Register new supplier')" value="registersupplier"></v-radio>
                    </v-radio-group>
                    <v-form v-model="valid" ref="loginform" v-if="mode == 'login'" @submit.prevent="callLogin">
                        <v-alert v-if="error" type="error">{{ error | translate }}</v-alert>
                        <v-text-field :label="$translate('Email or username')" v-model="login.login" />
                        <v-text-field :label="$translate('Password')" type="password" v-model="login.password" />

                        <v-btn type="submit" color="primary" :disabled="!login.login || !login.password"
                            :loading="loading">{{ $translate('Log in') }}</v-btn>
                    </v-form>
                    <v-form v-model="valid" ref="registerform" v-if="mode == 'registersupplier'">
                        <v-alert v-if="error" type="error">{{ error | translate }}</v-alert>
                        <v-text-field :label="$translate('Organization number')" v-model="registersupplier.orgnr"
                            :rules="orgNrRules" />
                        <v-text-field :label="$translate('Company name')" v-model="registersupplier.name" :rules="requiredRules" />
                        <v-text-field :label="$translate('Company email')" v-model="registersupplier.mail" :rules="emailRules" />

                        <a @click="showTermsDialog = true">{{ $translate('Read the terms for Zoezi Developer Portal') }}</a>
                        <v-switch v-model="registersupplier.acceptterms" :label="$translate('Accept terms')" />

                        <v-btn color="primary" @click="callRegisterSupplier()"
                            :disabled="!valid || !registersupplier.acceptterms" :loading="loading">{{ $translate('Register') }}</v-btn>
                    </v-form>
                </v-container>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols=12 md=4>
                <a href="" @click.prevent="resetDialog.show = true" v-if="mode == 'login'" class="mt-12">{{ $translate('Forgot password?') }}</a>
            </v-col>
        </v-row>
        <v-dialog v-model="showDoneDialog" max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $translate('Registration almost complete') }}</span>
                </v-card-title>

                <v-card-text>
                    {{ $translate('Check your inbox to continue the registration.') }}
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" text @click="showDoneDialog = false; mode = 'login'">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="resetDialog.show" max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $translate('Reset password') }}</span>
                </v-card-title>

                <v-card-text>
                    <v-text-field :label="$translate('Email or username')" v-model="resetDialog.mail" />
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="resetDialog.show = false; sendResetLink()"
                        :disabled="resetDialog.mail.length == 0">{{ $translate('Send reset link') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="showTermsDialog" max-width="800px" scrollable>
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $translate('Terms for Zoezi Developer Portal') }}</span>
                </v-card-title>

                <v-card-text>
                    <h1 class="c4 c28" id="h.gjdgxs"><span class="c6">Allmänna villkor</span></h1>
                    <p class="c4">
                        <span class="c1">Nedanstående villkor gäller fr.o.m. 2025-08-28. See english version here:
                        </span>
                        <span class="c1 c19">
                            <a class="c27"
                                href="https://zoezi.se/terms-and-conditions-partner">https://zoezi.se/terms-and-conditions-partner</a>
                        </span>
                        <span class="c0">&nbsp;</span>
                    </p>
                    <p class="c4">
                        <span class="c1">Dessa villkor gäller för avtal ("</span>
                        <span class="c1 c7">Avtalet</span>
                        <span class="c1">") mellan Zoezi AB ("</span>
                        <span class="c1 c7">Zoezi</span>
                        <span class="c1">") och Partners ("</span>
                        <span class="c1 c7">Partner</span>
                        <span class="c1">") (tillsammans kallade “</span>
                        <span class="c1 c7">Parterna</span>
                        <span class="c1">”) avseende de tillval ("</span>
                        <span class="c1 c7">Tillval</span>
                        <span class="c1">") som partners kommer sälja via Zoezi till Kunden (“</span>
                        <span class="c1 c7">Kunden</span>
                        <span class="c0">”). För att Partner ska få tillgång till Utvecklarportalen måste Partner
                            acceptera dessa Allmänna villkor i dess helhet utan ändringar eller tillägg. Dessa Allmänna
                            villkor gäller dock inte i de delar som Zoezi och Partner skriftligen avtalat särskilt om
                            andra villkor i Avtal mellan parterna.</span>
                    </p>
                    <h2 class="c5" id="h.30j0zll"><span class="c3">Avtalstid och uppsägning</span></h2>
                    <p class="c4">
                        <span class="c0">Avtalstid gäller enligt Avtalet. Båda Parter har rätt att säga upp Avtalet till
                            upphörande vid det månadsskifte som infaller närmast efter 90 dagar från det att uppsägning
                            sker. Tillval kommer då finnas kvar och stängas ned kontrollerat fram till och med det
                            datumet.</span>
                    </p>
                    <p class="c4">
                        <span class="c0">Zoezi har rätt att ta bort ett Tillval med omedelbar verkan. Exempel på fall
                            där det kan göras är t.ex. om Zoezi ser att Tillvalet kräver för mycket systemresurser eller
                            att Tillvalet har säkerhetsbrister.</span>
                    </p>
                    <h2 class="c5"><span class="c3">Tjänsten</span></h2>
                    <h3 class="c2" id="h.gdbgst8507sg"><span class="c21">Utvecklarportalen</span><span
                            class="c21 c22">&nbsp;</span></h3>
                    <p class="c4">
                        <span class="c0">Utvecklarportalen (developer.zoezi.se) är själva plattformen för att hantera
                            tillval till Zoezi affärssystem. Till plattformen finns ett gränssnitt för Partner att logga
                            in på och hantera de Tillval som de vill sälja till Zoezi affärssystem. Här kan Partner se
                            hur många som använder applikationen, hur mycket det tjänat in på försäljningen. Partner kan
                            även lägga upp nya tillval, uppdatera gamla tillval.</span>
                    </p>
                    <h3 class="c2" id="h.dhdwdhilu73q"><span class="c17">Ett Tillval</span></h3>
                    <p class="c4">
                        <span class="c0">Ett tillval är en utökning av Zoezi affärssystem, som är tillgänglig för Zoezis
                            kunder att köpa i en så kallad tillvalsbutik inne i systemet. Ett tillval kan vara allt från
                            något som använder APIer externt och bara ligger och jobbar i bakgrunden. Det kan även var
                            Tillval som skapar saker på personalsidan av systemet, så som en egen dashboardwidget, en
                            utökning på kundkort eller personalkort, utökningar som gör att Tillvalet ser ut att vara en
                            helt integrerad del med Zoezi affärssystem.</span>
                    </p>
                    <h3 class="c2" id="h.1kl56lo3o7ab"><span class="c17">Granskningsprocess</span></h3>
                    <p class="c4">
                        <span class="c0">Innan Tillval läggs ut för försäljning till kunderna går Tillvalet igenom en
                            granskningsprocess där Zoezi granskar och säkerställer att tillval inte innehåller olämpliga
                            saker, samt att pris och beskrivningar är rimliga. Det är först när Zoezi godkänt Tillvalet
                            som det går ut till försäljning. Zoezi har också rätt att neka ett Tillval som helhet om det
                            exempelvis är en funktionalitet som ligger i Zoezis egen strategi och roadmap att utveckla,
                            därav bör Partner innan utveckling påbörjas föra en dialog med Zoezi kring sin idé innan
                            utveckling påbörjas.</span>
                    </p>
                    <h3 class="c2"><span class="c17">Friskrivning av samarbete</span></h3>
                    <p class="c4">
                        <span class="c0">Zoezi värdesätter öppenhet och samarbetar gärna med olika typer av partners. Vi
                            förbehåller oss dock rätten att, efter eget omdöme, välja vilka vi samarbetar med – utan
                            skyldighet att motivera beslutet. Detta för att säkerställa att partnerskap ligger i linje
                            med Zoezis värderingar, strategiska inriktning och våra kunders bästa. Dialog och
                            transparens är alltid önskvärd, men inget samarbete sker med automatik.</span>
                    </p>
                    <h3 class="c2" id="h.3uixqh91610s"><span class="c17">Marknadsföring av tillval och Partner</span>
                    </h3>
                    <p class="c4">
                        <span class="c0">Tillval och Namn på Partner kommer att finnas inne på personalsidan av
                            affärssystemet i det som kallas Tillvalsbutiken. Zoezi har även möjlighet att marknadsföra
                            Tillval och Partners via Zoezis hemsida och i andra kanaler för att nå ut med de lösningar
                            som passar kunderna bra. Här finns olika exponeringspaket för Partner att välja bland.
                            Partner har även möjlighet att marknadsföra sin integration i sina egna kanaler. Vid
                            tecknande av exponeringspaket tecknas ett avtal. I fall där inte marknadsföring krävs gäller
                            dessa allmänna villkor för utveckling av tillval. </span>
                    </p>
                    <h2 class="c5" id="h.ohz56wcfy5ej"><span class="c3">Prissättning och försäljning</span></h2>
                    <p class="c4">
                        <span class="c0">Partner har möjlighet att föreslå vad Tillval ska kosta. I granskningsprocessen
                            kollar Zoezi rimligheten i prissättningen och har rätten att sätta ett annat pris, Partner
                            har då rätt att neka försäljning av Tillvalet till det pris som Zoezi föreslår. Båda parter
                            måste vara överens om Prissättning för att försäljningen ska börja.</span>
                    </p>
                    <p class="c4">
                        <span class="c0">Försäljning av Tillval sker via Zoezi. Kunden blir fakturerad från Zoezi för
                            startade Tillval på samma sätt som övriga kostnader Kunden har för systemet.
                            Affärshanteringen kring detta finns som inbyggd automatik i affärssystemet så Partner
                            behöver inte tänka på betalflöden själv.</span>
                    </p>
                    <p class="c4">
                        <span class="c0">Tillval kan också vara kostnadsfria, om Parterna kommit överens om
                            detta.</span>
                    </p>
                    <h2 class="c5" id="h.u96yhj2txw1u"><span class="c13">Ersättningar och betalningsvillkor</span></h2>
                    <p class="c8">
                        <span class="c0">Fördelningen av intäkterna för försäljning (både engångs- och löpande) av
                            tillval fördelas enligt 70/30-modell där 70 % av intäkten tillfaller Partner och 30%
                            tillfaller Zoezi om inget annat avtalas mellan Parterna. En Kickback om 5000 kr tilldelas
                            Partner om Partner säljer in Zoezi MyBusiness. En Kickback om 5000 kr tilldelas Zoezi om
                            Zoezi säljer in Partners tjänster som av någon anledning faller utanför eventuell
                            tillvalsmodell. </span>
                    </p>
                    <p class="c8">
                        <span class="c0">Utbetalning och fakturering till Partner sker en gång per kvartal genom att
                            Zoezi skapar underlag och betalar ut eller fakturerar belopp till Partner. Utbetalning eller
                            fakturering sker endast om Partner kommit upp till 5 000 kr i ersättning, om beloppet är
                            lägre än 5 000 kr så sparas det och läggs på till kommande period.</span>
                    </p>
                    <p class="c8">
                        <span class="c0">Partner kan alltid se hur mycket pengar som har tjänats in i
                            Partner-gränssnittet av Tillval.</span>
                    </p>
                    <h2 class="c5" id="h.4ae3w990yn1"><span class="c3">Zoezi:s ansvar</span></h2>
                    <p class="c4">
                        <span class="c0">Zoezi ansvarar för försäljning och eventuell överenskommen marknadsföring av
                            Tillval. Zoezi ansvarar även för generell support till kunder. Zoezi ansvarar för att
                            Partner får betalt för sin del, samt har har tillgång till Admingränssnittet för Tillval och
                            tillhandahåller testsystem åt Partner.</span>
                    </p>
                    <p class="c4">
                        <span class="c0">Zoezi ansvarar för att det finns dokumentation (men ej att den är komplett) och
                            att den uppdateras löpande allt eftersom saker ändras. </span>
                    </p>
                    <h2 class="c5" id="h.1t3h5sf"><span class="c3">Partners ansvar</span></h2>
                    <p class="c4">
                        <span class="c0">Partner ansvarar för att Tillval följer lagar och regler. Partner ansvarar för
                            att Tillval inte innehåller upphovsrättsligt material, skadlig kod, och följer
                            personuppgiftslagen enligt gällande underbiträdesavtalet. Partner ansvarar även för
                            Tillvalsspecifika supportfrågor som kan komma från kunden samt för att till Zoezi
                            tillhandahålla en grundläggande dokumentation för Tillvalet. Partner ansvarar också fullt ut
                            för underhåll, vidareutveckling och förvaltning av Tillvalet. Bristande support eller
                            underhåll av Tillvalet från Partnerns sida kan föranleda att Zoezi tar bort Tillvalet.
                            Eventuellt borttag/inaktivering av Tillval behöver dock föregås av dialog mellan Parterna,
                            såvida det inte råder akut säkerhetsbrist eller liknande.</span>
                    </p>
                    <p class="c4">
                        <span class="c0">Partnern förbinder sig även att tydligt märka sitt Tillval med följande
                            information:</span>
                    </p>
                    <p>
                        <ul>
                            <li><span class="c0">Företagsnamn</span></li>
                            <li><span class="c0">Kontaktuppgifter</span></li>
                            <li><span class="c0">Hänvisning till sin egen supportkanal</span></li>
                        </ul>
                    </p>
                    <p>
                        <span class="c0">Märkningen ska vara synlig i Tillvalets gränssnitt för att tydliggöra
                            ansvarsfördelningen gentemot slutanvändare och säkerställa att kundens kontaktvägar är
                            tydliga vid support- eller driftsfrågor.</span>
                    </p>
                    <h2 class="c5" id="h.4d34og8"><span class="c3">Personuppgifter, underbiträdesavtal</span></h2>
                    <p class="c23">
                        <span class="c1">Genom att registrera dig som partner godkänner ni även nedanstående
                            underbiträdesvillkor.</span>
                    </p>
                    <h3 class="c25" id="h.eknmrt10feuq"><span class="c12">Definitioner</span></h3>
                    <p class="c4">
                        <span class="c0">Med ”Dataskyddslagstiftning” avses Förordningen, svenska
                            genomförandeförfattningar till Förordningen, andra av EU:s eller dess medlemsstaters
                            tillämpliga dataskyddsbestämmelser, övrig framtida lagstiftning som är tillämplig på den
                            personuppgiftsbehandling som sker enligt Avtalet samt vid var tid gällande föreskrifter,
                            rekommendationer, allmänna råd och tillsynspraxis från tillämpliga
                            tillsynsmyndigheter.</span>
                    </p>
                    <p class="c4">
                        <span class="c1">Med ”Personuppgifter” avses de personuppgifter för vilka Kunden är
                            personuppgiftsansvarig och som Zoezi i egenskap av personuppgiftsbiträde behandlar för
                            Kundens räkning.</span>
                    </p>
                    <h3 class="c25" id="h.9dtfh7dzuydx"><span class="c12">Allmänna skyldigheter</span></h3>
                    <p class="c4">
                        <span class="c0">Parterna får behandla Personuppgifter från den andra Partens system endast på
                            den andra Partens dokumenterade instruktioner från tid till annan. Partner äger ej rätt att
                            få tillgång till Zoezis kundregister eller annan kunddata för egen bearbetning i marknads-
                            och säljsyfte. Parternas behandling ska ske i enlighet med Dataskyddslagstiftningen, Avtalet
                            samt endast i syfte att uppfylla Parternas respektive åtaganden enligt Avtalet. Anser den
                            ena Parten att den andra Partens instruktioner strider mot Dataskyddslagstiftningen, ska den
                            ena Parten omedelbart informera den andra Parten om detta.</span>
                    </p>
                    <p class="c4">
                        <span class="c0">Parterna ska säkerställa att personer med behörighet att behandla
                            Personuppgifter har åtagit sig att iaktta konfidentialitet eller omfattas av en lämplig
                            lagstadgad tystnadsplikt.</span>
                    </p>
                    <p class="c4" id="h.17dp8vu">
                        <span class="c1">Parterna garanterar ömsesidigt att det ska genomföra lämpliga tekniska och
                            organisatoriska åtgärder på ett sådant sätt att behandlingen av Personuppgifter uppfyller
                            kraven i Förordningen och säkerställer att den registrerades rättigheter skyddas. Parterna
                            ska därvid vidta alla de lämpliga tekniska och organisatoriska åtgärder som av Parterna
                            anses nödvändiga.</span>
                    </p>
                    <h2 class="c5" id="h.44sinio"><span class="c3">Ändringar i avtalet</span></h2>
                    <p class="c4">
                        <span class="c0">Zoezi har rätt att ändra villkoren för Avtalet. Ändringar träder i kraft en
                            månad efter att ändringarna meddelats Partner. Partner har rätt att säga upp Avtalet till
                            upphörande per dagen de ändrade villkoren träder i kraft, under förutsättning att uppsägning
                            sker senast en vecka dessförinnan. Om Partner inte säger upp Avtalet anses Partner ha
                            accepterat de nya villkoren. </span>
                    </p>
                    <h2 class="c5"><span class="c3">Tvist</span></h2>
                    <p class="c4">
                        <span class="c0">Om en tvist uppstår mellan parterna i anledning eller i anslutning till
                            Avtalet, ska parterna först anstränga sig för att lösa tvisten via förhandling. Om sådana
                            förhandlingar inte resulterar i en lösning inom 30 dagar från det att tvisten uppstod, ska
                            tvisten avgöras av allmän domstol med Linköpings tingsrätt som första instans. Svensk lag
                            ska tillämpas på tvisten.</span>
                    </p>
                    <img alt=""
                        src=" data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARgAAABnCAYAAADbjV0sAAAABHNCSVQICAgIfAhkiAAAIABJREFUeJzsvXmcHddx3/ut6u67zIrBYLBxBQFwg0haFDdZEkVqNWVZsmiBoiRri20yTp7iKJ/Ysv2Sd4HEcp4SfZ7fixPHVBbKtkRSA9mmbJHaLIHaZYoURVogCS4guGIZYAaz3q276v3RfWfuDO4MZiUpZ36fT0/fPuf06dM9fX5dVadOHVjFKlaxilWsYhWrWMUqVrGKVaxiFatYxSpWsYpVrGIVq1jFKlaxilWsYhWrWMUqVrGKVaxiFatYxSpWsYpVrGIVq1jFKlaxilWsYhWreAkhL3UDFgcXSvcEDJYDqklAbAFhmxJUlVqY3lMudnJ1x/JGPkwYiBLynQmbXpWwW+wlvoFVrOJ/C/yMEIzLq266P4RDkVbi4kSBNaOJbawr6+tC3wSyLkm825QOU/Lm6o5XERlDGUb0GK4DKEcwOULiI4QdFfrW1+DCeJVwVrGKlcHLmmB27uwPqp35tnK9ui4O2FLGd5hzSU2SrdXYeutmXXW39rp5mLgFrmjdTBIREg3cEE9UzQKpm0bjFgQjBOEAoT4B8hOCcB+BPUs+f5zC5jK7L6yD+Et936tYxT8WvCwJ5qabbolGRzvXjqttS0ReG1vy6grx9nqSrI+TuFBPPFdPkqCeJOIqmgAxQiKQZHtHMAHLjmNXTwI8CXJm+SA2jcpE0VGi3D4C/QGq38fyB4k6hvijqyqrRLOKVSwdLyuCuemmW6LKUGF9PZRL6/gv1mP7+Wpc2Vy1els9tpyZBbE7iUhKJCoZsQixpPtEBAOssZ/cfPK3Z+XqErjlg9jzbRXC/HPkw70QfgmiB6lVTvDpt5dXiWYVq1g8XhYEU3r93nBg/cF1Vefna9jOShxfWU3q62r1els9iYOEVDJxVVwVCxQTJVEl0ZRoEtGMYFJyScikF0+JJcFJHMyNxCF2x9xxPK0rDLBcoUq+cJRC7nsEQT8a/pDEBvnjt1Vf4ke0ilX8TOIlJhiXj173uU4KtVfWSa6vWvKmcr16VjlJ2lxMXBUCRcIACUOCXEiYzxHm099BFCBBAKGiYTApmZiAOcQOtcSomVOJEyq1hIl6wkQtZiJOqMdGbEacGHGSUHfHgoA4KtS8WHiWKPoamr+dOP4pxyZG2HND8tI+r1Ws4mcLLwnBuLuwB/0v9+4589ix2nWVON5ZI744UekO8hrkihHtnUW613bQvbaNjs42OroKtLXliHIBURQQRgFhqASBoqoEgSCS3o5nm7kTJ07sTi22dKsb5XrCaKXO4GiFgZEKR0YqHBmaYGCkzGi5xlg1ZqTuXg5yE1Yo/kSi6PPVfHT31mDDsw/v3lF7KZ7ZKlbxs4jwxbqQu0dAEShQoe2J7c+dvcO3vrtai98WdOQ2t3fm8+1dBTq6irR15InyAYEqmhGHqpDxx+QekSmGFFJWwdODRoY37Rw8SzAHd1IVyiAxp1KLGRytMTBa5uiJsjw3VG4/MFh79fNVO7tKeMFrzmn7813ujwNVoCYiq2SzilXMgRWXYNw9APqq1epFInK5qp4rIltFZHNcS9bF9aRTVEQUEEFFkIxM3L1RR8oGTPLFVPoC0ZBypohJJtNFBDPHPJV+zCE2Jzaoxl4JRfav6wx/4O77gPvCMHwcGBaReDHPZinopz8YYkhX8hrn8oLfA7ab3Uv2E+qnP+jgcHiMaljoScK6uUZekcjzUpeq16XgHlSS7kHiMsT7IF6O684XJUq6A8IKHVGhJwlJykHkeQGoS9WjEUx725Lq8SjuY7h+LbuX5X/euO5y1NVAB70n9etnydvN3Fyfbx3N79dN3BTLIgc7VpRg3D1XLpcvFZFfFZE3ish6Vc2rak5EQkCaSWQaoTBFLD5V37T9UtAgFJhONs3pzeUy8nERqu5ecfdn3f2L7v65XC73xItFMo7Lnp5PdpmVtwqsXWp9ievs74DLmOSSp4PjO47cwMLtT47Lp/l0uJ4X2uud4YYktG1idp6Hfo7DRkHbHQscTGHCnaPicsCVx7Qa7tcoeqFvqDy+XJ25FfZSCgf6KCQjrPMC56hwoYtsR9kMdDgWCJqgNkqshzyUJ4KaPRJL9Hh0ou3oTj5WWWznc1zu6N21iRpnu2i7YtP+F0k4x/9mAQhic/FgPBlN9r+XXcdP1d5bKRXyvZwtNdY6gUtdn3u0Un9+MYS/YgTj7lGlUrnK3f+5qr5RRNZqiilbSUYqcxHLbKTSfDwfwplJGjPzppHNDKKRGcfujpm5ux9z937gjzOSWXEj8GfXlrqChOstlN8E1q3UdRRzR8dx/0sR/sd7j+9+YSHn99MfRJ1PrJnw6g6J/C0Ir3XhbIU1QA5Qg0kJTMFAE7A6MAL6rIv9gFrw1aJHP/7JaHVoOSUax+Uv+FRbrn1sCxHXmPpbRLgQtNegoKCWdXhF3cDAEoWKO4Ogj6PyTRf7RjTQvf8G/lV5oW24lVIh38O/FPVfdl/6x2I2iKpjjIj5n+VP8Nl3sfvEbGX3Ugpf6OJSDf1fWaDnaULsbj8IJ6I/2ln9NwcXSqYrYoNxd52YmNghIr8hIm8WkR5VlVORy1zEMtt+AW0CUrJw92nk0bi2iKTk0iQ1NfJpOk5tQipm1gfcgFm1Wq3+V3c/KLLi0w66PPJX4P5K0GClLmJoSjKiByjrBmDeBHM3/zl/onfflsS5XvF3I2wDLQoWoFNf5db6nWJGJ9hGdS7yKPmFsiV3bu8JP3/L0C2PLkTMnw0lSrqn4z/0hlq91nPyAdxeLWg3WIAijXZpUwt16m+7mK0xOEM9uRzTtyVrhz93W/UTd713/PePLqQDtsOaROTVhlyCkFvqfc0GT82SNQnk8koh/CIVZiWYgxAWVC8w8deo2SZEE4EgiXzPnuqu54EF2R2XnWDcXarV6hZV/QhwnaouilxaEcpipJiZkktzfc1kMy2PTJJxx2eoTI16MpLBzPpc9QZxPwF8Gjiy8Ke2cCgq03rASsBwEUJrQ5mY3yl385/zg50nLlOXf+rCLwjegzaIUDHDFGKwxMBU1c1MUomBEDRQRUEViMQ4z9T+mWI7OrsO/8mtI6XvfITdlcXeUomSnl+ITouj+o0i/mu4b2tuH2apYziaoBiAmQlooBCihKgGCgFGXsReY7A1aKtu+2zbrv/lA/7kgr7yiqqjK/2/NLNAXE/Z39vpFpPRNoUcqoEZotAmec8xtvDrroQEs97dfwV4t6quU02HkVuRSyuSmUkacxHLfKSYmfXNlFxa5U1ihjQzPWsayZwOfKBarR5z9z8XkfFTNmyR6JS24XGp7MOTR9x000LOFWy2B6ao5jFrb5YwDK2q2SESH5pP/f2UckPdQz8fBMlvmfAmhTZUBTM3iBUqqnoE4wl3ng4CBt2lKkaEsFZVz8BsO8Zm0GLamQkV7cHsreR0TWENf3TridLXFkMyjssdhU+c5sXaza76IVE9fTLTqIGVET2C2JMkdpBYh1y8Kk5OAvpwzsZsO+gGsGL2rPIYZ7jxayHWdXvvrv/ix33/fEimg96hYTv+Axc50936VOa2uZjP+v+bhIoKZj2o5qelq1Yl5oCGumhyXgyWlWDcvb1SqVwDvFdENjY64ELJZTayad4voY2T+5mSSwPT0uZJMkmSbBGR91ar1YPu/rWVsse84/jvjH1u7a6/zCF/76LtCzv75I9kXE9EYS2R3YjqrwAdQEPSeMIs+E5t2E6pHpUoaX1dcJFa/GsIb1BN22aGgY4pPIzL3dTlnkCSp0lkLC9t9apOeF7bZSy2UCeSDiLb7Hl/LZb8khg/B3ShKqgWMbsS5aZCRzhUGit9b6E2mT1du3oIeK+ovl+w0zKJxQ0dVewRzL+C6zeohActH4xFuUodIG/tMn5sIu/ddClypqu9yUP9RYzzVSmoopj1mXC9JH5iT/ET/40yz5+qPdfx0dqe8if+zHL1r0ggOVq+ZVNQhKQezEpCQiKe8/Xi3GRmVzf+B5lU9oglwbeHx3pnVY9WAstGMO4elMvlC0XkRhE5fy6D7qlUopbq0wqg2fbSSn1qxqSbzQw0kUxoZpcD76tWq49m9phlb7ggziAjJUqP7uD8JRvpu9iXH+/hHe5cbEabZhykcMydL2kluOfD/F/Vj7B7znrOa8/1SVK/HtXrwJpJ6jDClzT2z4kUHuw7UR6/hl1Jqy98idLwNRUOPR/xSBDLtwjlPSa2E+MMVRTVohmv0yh+4vy8PEuVg/O9z72UwsPomxF/j8GZmklWoAMKdxPLnyWB/PjxoWRsF//WpTK9fY6P7RreNbgDnqOjsM+S6rct5x/G9DqUNamkxgYJeU/cVn/sb8ulL/wSu+dULAXxUrl06JryQtTq2b9bA110xTEXesA2hTaA7B6PiPkdNY9+vBw2rIVgOSWYPuAdwGtEpND4sjfQUtVhecjlJNVmBk5VxzQjb6t80m//XCST3WvBzF4PXE9qjxk9VdsXi+XyTRnp4hWi/m6HV2jDDmBWxdkrlbA/qJz7wqnE/X5KuTiovR7x64CehlqkqkdJ7C98NPqf62vxU9fyu3Gj9bPd024wBhm5hVsebF/7wuHAgmNocjPG2aiKYp0o7/Ai9/VXSy/cwO5TGh0dlz1du84m8ncDFzfu0+CEGndIPfhTHTvvsfdmQ/G7W7QvewYO1HzMj32GXd8urgmPeGijmL0H1e5UkuFsUb9xfE34ICd48FRtm7znJaKfUi4Wfo5A3isiW9DUjGjoqLrdZXH0tx8c/b3BD/H7S73UgrAshiV3z5fL5StF5J0i0jsXubSSZBqbmZ30ezbMHDqeC/MtOyfZ0fAGbt32puucDrwzjuNXuvvKGmGXAMeF/P4zNfD3CbxJVSMgFaede0Xls8FEsm8+/i9Jns2E8mZEd0zacFTHHdtjiXx6fy1+cqG+LDdzc/3xQV6oD9mtbtwGDGb1CnCmqP9C3B5sd/yUL8CX2FWMc/pOg6vQ7KNqTKjzV17TT79n7N88uhA/H0H8I+yuDJ/Y8HBi/v/h+mUzUtuGEppxtQf+2i/2frJzIfe8WJQoqbVzLoF8RAKumLpHqyr8UOvhn4Wj5x1YrL/OUrAsHaBSqWwCfgXYKiItVaPm37ORy8zyrTCbf8pitlaYq43esMXMMnqV1SsiclGSJO8ilepelridXb3WFr8L5R1AF9CwRzyNBJ9X4Z75SAe3cEtEm16JcAWaDbUasZl9z+vyhWh4x9OLlbZ2s9s+wK4B9XCPwz2pIRZQDRCuougXf4Zd+VNUw3hHeJZYcq1im9LbxFz5sSbB5/aPJ48stuPdzM318cHNjxP7nwEPpfYmUNV29+St45WJLSVKK/6R2bYut8FyfqMEvInMhoZZYqqPiPmtbaPJA4txlFwOLPnm3b3o7pcBV4tIsZlcsvyT7S5zGHDnGm6eD0GcCq0IqsU9tWx7M8nMpspldXaLyNW1Wu3Kl6MUcyulgnRzjavfAJzZkDocPS5if82Y3bVzYNe8RsJ6Oo6vkTC5RODMyUTlmEjw9UiKDy71xRbE9UTyCIl8E6zJcKpniCWXhOtyPXOd309/4EF8JYGe1xiOVmxIYv9iTO4nS1U1b+bmelvU9j1xvqnY5GibK5cR6vYr6Y2WUv+p8Of8p/Ygqf2iqL7LjPVAZnfhsCL9VsvtPZUtaCWxpJffU5+XTcDbRWSDqspMj9dphDFjNGa+9pbZSGUpEstMomlxb7P+nk1FatSVPYdtwFuA3tme30uBEiUtdAaXeOg3AhdP+oCYlQXukWq4J6jueHa+X/XYq5vc9DxrkoIwfiqx3Ltz6OMjy9HmG9hd0xo/RHSfmaVGSiXn6EVKsnnOk7v2dRPKq0idIlO47iPm++8b/t1lGVF5x/HfGQsS/wauT01KMc56iXjFCY6vmJp0C7dE4bryZRLI+4FzJ21oquPu+uUgsS/uH68NrNT154Olfl1zZvYK4LUikp/ZkU+SBJhbBZmJ+ZLDfMlltrqa982YlQAzSWy2sll9HSJyebVavfRUD/HFguNy7proDCK7QdA3olqEyaHkByX22yujycKkjkjPMrGzJl9utIzzUFDVZdX5NV980s0egSl3LxHbIrFv3ktp1sGKWshGYBuTqgMxcC85Fuz2PhsE8WiYh1ztccXS4GSqgXtyUdgZrsgHpkRJu9e9sAW3f2JulzfsLmZW95h7Uf1s3yCPvZgTRlthSQRTLpd7JZ3EuFFT28OstpeZqtF8yKV53yq9OW++5NKKtOZSu2ZVkea4h6wuBc5V1Wvd/ZR2ghcDe3o+2aWaXI/YTrBuoCFOH8T99vww31yIA1uJkiJsVs9Ec8Bg0M2fLJbr83LOmy92Dn18RFWe0IaxFwDt1dA2jfS2FWc7L3DdArZpylvXhjyQhwNlWaSrBmJ2HBcLHgGdHDkU1y0JcW8//cs6pcNx2bYutyFJ/FdFeUuzz5E6BwT/n53Hkh+t5CTR+WLRBOPukYhsAa6UbFh6TnKZfu4pDbnN+8bvuUhjLrQ6b2b9zeVa3GtriWuGJNPCFtPp7pfW6/XtczbwRcCtlAqxlq9F/N2GntbksTsixt8Ezp2/zK7hhdS5lfGihKx1dLKDK5wQ10NvZ9eCJ//NBUE8rumzuE4Sl2HtlrB2/PjErASe2oa0ezLBGSS2I0MDm5c1DOoN3JCYcQBskmBMrNcD7R1n37LaYfb07WoP6vEviHI9ZhvSi5kjdgQNbg9CvvlS2l2asRQJpuDulwDniEggLYy7M/dzpU2NA2fp5iRxQlJPSGox9UqdeqVObaJGbaJGdaJGZbxKZSzbxquUx6qMDVeYGKumz7sFWSzENnMqtJJkZtQTiMjZZnb5S2ns7ac/aOsNLhL3G8FeOekHYlRw7rFYv8DQjucXPlO2vSgknYJNdSBnEGxoJYZEJSdH0SkVSdG8IJ3JulzLDuy4GL7RG+oRgDAiMSdu4qZl/7oHAYcdJiVARTvButv7ls/fbC+l0EyvlNDfJ+j2ZrcATfialO0vdw7selHmw80HS7nxLhG5Auic2SFPIpIs3RLDEiOJk/R3nGCx4Vm6G3hiJPWE6kSN6kSVeqVOXI2pVWLiekK9lhDHlkahS4zESIOBi2CiBMWI07et49yLNhEUW5MenDyreqZE1chvde60clMnTCvXRFQbgVcCn2OBM1GXA47LbWs+cXrg9m4XfaMoqbRhliDsk7rcsXZ0zX1vW8RoT9hHmCSaJ2BSBXAYc5/v1MiFQaoy4hET0riaEuJWFKu1VEE+zafDLlgDlm/6ltYIguAv+FTbn/Of5n3tQt/YKb86SV1qos3/YysiQXstseXxN8Pl9twfbBGrfwDlSlRzkNpdxLlfE7lNx3nspfB3mQ2LIhh3D8vl8mYR2SEiEUypG0mSpJJHbCT1GKunx7VynYmhcSqD6VYdLFMdnKA2XKE+UqU6Vp2UTpLYsnWNBFfBstUDTLK1j1Sz4N7pigKmStiRo29LLztefTZbzltPvhCdRC4zSWM2kplZbs5nMXWBafU2/W4LRNawTD5HC8Wenk92SZi8w812CvROzb/hOU3kjqrnv/42/sWi1IVaQhgIuSy2QwqhphKsiDu6B1JTsSpG0rCpOJrPjQctJZgcLwSIR80TOIGNBHZDtHbsdQu5djIf+g1sUzoRcqoJKhSKg8vgDoLL7ezq9Xb/gIT6ViAdnTJzdQ6QyGeKUdsP3snHX1ZhXBcrweREZBvGJvNEE0uoJjWq5RqjQ2OMDowwemSE0cMjjL8wTPnQKPWBCXQsRiuGVhOoGcSWTa3wdCUAFZIg3VuoWCDpFipJkBJJWmbqWAoRvZs72XblWWy/7HR6NnRSaItOVnNmkbLmIpnm45m/51KjGvXVE/PRcvxEZz7YG8KLOgcE0mFM88PXiCXvBz2j4T4OOqzYl+KEO5fiPh5MREJ7TZq5U9TqEvuK3KtWMNo1oYnXZQ7ijtaSIx3plIZneToPiQ/PK9aanXr28nRIgGZzgCB1CIwtmOguCAuybp2MPX272qWu14n6r2C2gUlPeR1C5fZYw6++89jHV2xqymKxaIKJa7VzxoZGOwdfOC7Hnhrk+QNHOXrwGNWBCXy4ho7UCSpOWIewDkHshCYEDuqgLpP/YgFEBQ0FIkFCRfA0HUCM9D3K9mJoGNLW187przydc197Duu39FLszKVRO2bCfXIeUTOhtJJY5iu9TCOb9MTJ4zgxDh8b555HjiTffWr48Y0b13z7D962/UX1pOynP6ive/RiN78R+LkmF/mau32HQO6YGNn89FLFaXedxrWeqDu6ciK6mjNPjUOSQuC5sjbP9MmmRMzP6KpLFDzM3CVY8rO4hVui2I+8iiD+gMN2zSQyMxtX168FJn9149DvH/4A/+dSL7XsWBTBHH7icHT80AsbnrjvH8In/v4JygfKTIwZSdkpJAF5C1ATxBVBERcCJCUW0mnn4o7QRDLm+KTZzbJe2/wPtuxMp7CmSN+FG9n6+q2cdtEm2te2EUbhTCFlEo3/sDRIYRYSaaVCwTwmS6aFABger/Gjxwb4wnef4FuPH9FDHnVNtHd2zVnBMsPTuCeb1eKdCG9uxAYxw1Aeph58PhrsvP/Fnln7YqNtuOLlmZM1soBStswkqK1j7YzhjHlQWfTHxXH5/LpdW9z8/QhXyOScMWKBhwz5zMjQhkdfTnaXZiyKYH78ta8ElVFre/bhAzpycICuw3msLiQuRECAEyAEpBQR0JBaMmmFBrn4lKDqAuZoM8kAkyQjQlgI6NrayzlvOpczrjyLzvWdRIWIRpye2YaYJ4lDZFKaaWWUnY8U05qAoBonPPHCKH/9/YN85f6nef7YCKO1RCrtbWsJimcCDyzoIS8Be3o+2SUkbze4XhqBwc0c4YgkwRdCsy8vJoZsK4iYT1ORAhOZxwTERcNmBmUyh9ZuJnWIJSFubo0JRxW9X6x12Mg5gnItCC7q4vKEBPat3LEdiw5AtqdrV4/FutMDv06VZt+lp8Xkz0PyP3w5fygWRTDHHj5UryuHysPlclil0FGNqGSEEEhDSpnapKEW4Zn00kwyGcRnIRkhyIcUz+jmtKu3cta12+g+aw259vykOjSXPeSkUaSMZJrz5rK7NNJbEY67E5vz3LEJvvbAIe6671mePDTM6HiFuB6juAT1pMssOYOSK7tXPF4v/ZRyiZdfT+DvF3T6tH3ji6K2Z+fIrqHZQiYsBIFgsWJu5pNW3kTzSVHzrEBMv8A9TJycSZPyIlhC3JIUxiEuQKw6Ja2oc8Bj/yOn8EDklRYvzslJjeVLToXyaLVZWSTo88rOgV3ji5UubqVUiCPeLiTvcXRySoSjx1Wt38eju26o/O4SrTsri0URTPFodXS4mHzLKvGVuQpXiNHt4umaRp4qMlME45m9xZHM7tKIrcJU9FtwkBkkI6FS7Gun79VncfqbttN74QaKa9vQKDilpy/MJm2kJDNblLqZmI1czJzBsRo/3H+cL/3oOX769BDHRyvUa/W0/dm1NEmKuG3g0P0ByxD3Yy6UKGnSxcWovw/0lc12F1X7ntWC/s2Dvmwu/LFKjFPTpvsysbxUdWUCWLfHRUQKTXFrHNdyoGHLL3g7O+qx/nRCzJImSsoFFlRvGP3dEyuuVgzAYol8L6XwUGfwSsE+AHJBs++SiH2dmnwhqJy7oJUeXgosyop1w57dteqhyg90NP5U93D0d0liVSeTVGioQenWkFykoR65T4buEc+Os7I0yoiQ7yqw/vIz2HHTVez49SvYfNVZtPV1oNGUODwfT99mLNWxLmsioxN17ntskD+9+3H+5O7HuPexYwyNVPDYplRCBHUncC9gtpahAyunNpDq6ucXotM8lF9BeBNY0zwje8RN7ohytqzu42FQq2ui5XS5kRSKdiPeMdd5i0VSZ403j9KgddzKsbZek+oGbkiwYKjZ+Q3Rbs8nPXvYtaKznJcCB3mhmzMlij8CdmVTfJcEeEiS4HNdw73zitXzUmPRjna//fVPjf8V//ontaI/PpS3WLC80JBgptSflFSaySUdz0nzBKQhaQgioMWQ9q1r2fiW7Wx84zY6zu4hbE9HhyYNwi3mErXaNzCXk1yrnNlUpXpsPHdknG8/dJRv7xvg4LEJRit1LEkIMrWv8R9vePmqxzlJkm5v27CifjB/wafach3163DfCaxt+H6ochQP/ppy+NWd478/vhyq0SRGusvWMzoi+JTvhVsPuWBdP/3BsncA1Q1iSeeUNGJlQU4EQW12G0TCCxIyBqT+Kc46Mz2t2FvIc/zFd3ycD+7s/MO1qvWdSPILqE76uxh6SBL/s0AK312s79KLjSW5MEe4JUbkmExJH9MlGGlIKg0pZtIkmKpNnhGLRErhtC763nAOm687j67z+og68+mQ9TwkjFYkM5en7lz1zCybJM7xExXu2zfA3h8f5qmj44xUY+LYCM3BwSbJpWkyJKCiYWBejNcOrJgE008pV183dq2b/yrC2UwOY1IRtS8zEt22v1YbWG6VYCcfq9zh/+5oOv9G0wmPwlpJ7Ax6DnQwtFTvjynspRQeijhHfGqxuTQcpAwUR2zWCZqCPUU6QXJrdlY3ITsmRutrWMGQpovFrZQK5Xz9Lbi/T2Bq1QN0SJ3+QPjSDUMvb7tLM5b0VQ3ICUjQ6E4pifiU6uNZGj5tFAkHzcoFKhTWd7DhLds473dex9abrqDn0s3keoqT5DJfI+5c9piT0udBWu7O8EiV+x48wm13PsoXv3GAg88NU5moIYkRuRORboE3jZbhk1voHgTuecaLK0IwjWj+gr8P4bKGh6uZ1QX7jtfktk21+KmVmLYviLvbs/jUomwGa0DOi8fr6+c6d6E43Mt6wc9FpyYuqtuAG4fva1aBZraxEj4LPIc1hVEwvZJ8fetyR5tzXEqUdLH19tMfFNYEl4v7BwXOb/5QgH2L2G/fN8Rzy9nmlcYSH/C2NLe6AAAgAElEQVQYYJP2lIYUM6UCTUkw6czjJhsMQtSVp+fK09nym1ew/bd+ng3XbqW4sXOanaWBmc5si8V8pCF3p1Ku8/jjg9x19+P8zd2Pse+RY4wOV6CeELrP2FJRMHAnaCLTSbKRlRm2dVx29HC6mL1bfHp8F4HH1IPPJ8MdP1jJafuJ84yLPpXFWUFVIwvsEmmLL1iuMAWOi8ecj3G+2bRo+fvD0J6fizyLHaNH3XU/NC8bZttRvfKczvyc0fAWgr2UwtvZ1Xt+njMvyIdb+jv+sG8hROO4JPl9Z7jaBw1+fir8aGp3IQ7+Ihjp3vdSx3dZKJZEMAk5V3WfMtR66mcyqSM0jqfUI3EICgEd5/Vy2q9ewrbffh2nXb+D9q29BG3RrB7czc5sS8GpVKV6PeHw86N8556D3PlXD/Oje5/j+NExrFontBnEQkYuqTF3cgszoglwJDELE+oMlZd9xOJvev9jhwX8gijXW9M61YINYNyp5eArH+Bfr+i0fQk5KiYPoxxrpKmzzdVfS/Gxjctxjc+t3dUpalcjdsH0qG3+IDGH5zr3Hcf/45gkci/Tlr7VbpfkugLx+fMJGn4qOC4DneFW1ujNtPv/6x3JnyS5yu4L2rlwviR7J7u6vY0bReytqkw6Zhp6SFxuq1n07eXyXXoxsSSCKVJxjSkr6pMkAkypS1MqEQ4aKsXTutjwS+ez7Xev5qxfv4zuizcSdReQWdaTOlXsmLlmPM/pLDcjz8wZPj7BT37wDH/7+Qf59tcf4/CzJ6iVU3UoaCKW6CQJZro0EzRvaKIiy76aXomSTtQnXuPuH8Q5Z2rolglxvkZN+veV64dWeij28UHGRLnPE9vfNHenC+FtSaH++n5KSxqy7qeUE+VqNHgzNC0Qb/aIhvpg38jcgaMEPAnsR+76YENNUkVduMwi++U9PbvOWEr7HJc9Hf9hnRXqH5LA/xmi1wHXmHCjFfWiIvtOGWzsVkqFcre+UdRvRHWyPWY2rsZfeWJ/+8HR3xucq46XK5ZogwkTcRkRyyydMyUYMrVIhXxvkXVvOIetv/M6tn7sNfS+5ixyvW1IqCeFdzgVZpLOXJHyTklQ5kyMVnnsgRe4+7YH+Lu//CnPPHaMykgViafUocC8SYKBaPK4QT42Kcmkv43AIZQkjkjqW8LHuygtj85foqQXrAku8lDeD1w2FS4Rw+3vLZE/Hx3f/MiLIU7vZrdVa9FPcL4LmhofVcXhXFQ+ZF1ccyulwmIkhX5KuaSLi8X9w4ZdPmVfoiKue93swfmof+ODm4+oyVeAA400hTbE3pvADf0df7io1R/2Ugpvb//D9UlU/ZCbvjeNnEcOJafoqCSMlGHO9u2lFOY7g1dK6L9ucOFkhllVXL+lqp993/Cup16uUwFOhSW+8PVYLTmWc0ybSaVh9BUh6szR86rNnHPzlZz721ez4a3nUjytG82nA1jzJZVJzCGVtCKV2SQcd6iW6zy3f4Dv/fVP2XvHTzjwkxeYGBrHqvVU3ckIZUr9sSytSaIxJ7RmcvGpc3Eis3ynnXhNT1T94Nsm1i+L4fP8XjYi9m4Re+vkGsRmrm6Puwef7wjb/v7FdB8/MFodknr4VeCHzbYY4LUW+v+R7+QNn1u7q3O+NokSJe3vK3XEfVzhofyWo29uXrdJsfstlr8Lju+YV2Clm7m5XjthX8e5h4YtRlUM3YT4r8dR/cO3F/7gjPm2z3Hp5/8pHuplm0fxTaj/U7CzJsNCGDVX+4bH+thOds36f3BcjuTDsySyD4K9etraVPAoifyvzuNrHvpZJRdY4jB1maDuJodD05q64eKTJBPkA7rOXsfm153DaW8+j+4LNhB25kBPPVt5puv+ZJpMTS2Ytcwp6nR3klrC0OERnrz/Ofb//TMcPTRCuRIT46gKgSqYpbNpLXUudklvLUxvj5AZpGaNvTURnKOBauD1s7vbiu/vbtOn3X2PLGFJ2f6+UkdS4y0ecr2hvU09YgTRr6vaXjwtt9hrAOStTQCqOuEdA7316/hobbYXfTe77W/HSvePF/hrN99iptvTpV5pc+MNmpNeVbljR6d+rb9Qep6BHeWd7LTm+hyXe9gVDPRRSEZYl9T19QTJ+yWQV4tZeyOODfCCu3yhOGI/etcC/GyehGPn1uQOLdrZmL4RJZeuxKhbRZLfpOinnx/x+c9GpZ/mBneMz9a+Mcjd0btrjQiXYvIeDfwtqE7FJDarq+tDSrBneHT9nIHF9/TtardYrxfhbc2jYwYjanqXVvQnYz0ThX7+78J873Mu1KTsuUEq81nvarmwJIIpsjZJGB4MExsOzHrjQEVCpW1dF5uuOJtzfuki+i49g/zaIhIGmE8trjYbmn1XZk3LyKYVycxWJ4DFxsSJCZ77h0M88q0neOHxY0yUY+rmiArB5Dy6jFw8ncHt7rgILqlrnpEOSZundVu2uWX7bEtH0RLyWpe2tvwZ63vXXLLn4YfvZAmR7eoenKdB/MuGb9em5TNNmFBnsyfyoTLldBxpCSiT2hPdqZ7oPf7TPdX/8D3GmHUJjLezq/xZ/vBvQ403qSe/YaabVFFVbTezy8XYWs8lvygefD3ofPSHtwWfeK4/KlXjiZyHbTW5Y/QTkeXYpKaXe4e/SUgulzR4U5gSvTlwDOcLnvA372L3gpYc2c1uu3WsdG8+ks+I0oNlKpcSYpyJ2ocsp1ep2de9e989eyr7n+zvKpWb2yeFYK1LsgP3N5hztYicNTnaQ6a6oY+R+H/VwL9zKiky9uBVovE7gdOmTRh1raJ2mrXZRyBZNulF0Uq8hoe+GHzynncef3FixyyJYK4B+zs4UVV/Nqd6ZtjTFm18xRlsf/slnHHNubSt70BzIU6jw50ci6WB+RDLNClmBsk0MFtc4OpolaOPHOGxvY/z7D8cYny0Qi0xEM0k25nScUYuYgQNZ71sa5BLQLoiZdAktbg7WIJYQk6MAGgvKhdu2eyvvnirv+vCCxdtF7mVUkE82YFw6aQ4PXmzugHsF015a6tzmyf8LQyCmD0ZF+qf9DG/Y7YvsiBeOlY6cu6a6DMqSYDaBzFORzVQ1Qiz9QLXmPurLecVFTsRmx+XYr2amORoq/WKsAaSNoeCQDgZICudSzTg2B5MPv2+4V1PvX8RHskfYXfli/rJL495xVX4LTO7QlWjzLbTjdkrXfV8U37D2+vDYnpcivVKjIS013pMWKtOG2hRsGha+2BMnR+7y5+2hW1ffufAx8fmbAyAJa930fNEp08HF2EdcL2r+vK6QieJBrp/XCeGbuGWF0WNXmIw4t0eFn9ntK0z/8zmC3uu6nvrjmjLm3bQs2UdUWdqGmioD3OhJZFwMlk0h11oRTInxdE1J67WOfHUIAf2PsEz9z7NyMAYlVqMSbp+tgdTway8+SsCuFuqLmUqUiCejY+lpScJRdIh+iBwXJ0gFNrbivT1trHpzB7OvaCPHds2V/p6u44Bi35n1va2RWWrtJv6SV576SiS5hWWfYkUR09TY/0uds02uwJIpYT+E/3PJYXH/nvQlhx3kg+ZcQGQy6StRvu6zFin6Dnm5oqKpSsOK0xRvRmWrTN0kERu90Q+99jw0tYzeufxj49+dm3pq1IPxjRKfgPjWoOuTNpqBKPqctN1AlvMzdVVgEBEm6b/a7o8K1RU9RDGV7yut1VHkwfex8fnN2oY+Do3yZ0kayohaOeyzy0xHNiszpoexkNmibJoTJd/XdQ9tkVFrV8awbjzim882lZ5/oTLlrXefe4G8mvaJoecG+tNL8ROMhfRnBTbBaaCSDH9zbd6wtjzw7zwg6d5+ltPMvjUcSrlGgmggWTRymaSS+M4RagCnrr+B5K2QzVNz6mikRLlA3KFgPaOiN7edjZt7GLTpm7Wrm2nu7tIe3uOIBTCIDgmoe5fiv1Fj08k3k1ZVMYwupasB811raaATA4jTHNUmx03cENSqpSe35HjL2KXxzXHTrDXgW7AKICly7emhDPl1gKTISotDbFQVWwA5T6vBZ+vW3TPgdHq0HKMjL1/cNfoHv7onrh9+HkpyoNq/nbMtpOuPqCt2jcVy1hdIQYrI3pEjPsskTujQfvOPpKjC2mfeHDcJRnHdAE2lsXHq0nbbsNSl0oHYct2jjPsxYRhVx/F6NZ0IuugBkwMsXnB117SC+ruPbVa7Z9Qs49qFJypUZC5NqdtNzPw6XaJxtYoM60xLSYxtprA2DJtqk1UBsscu/85nv7KfgZ+eojyaJXYHQsljeUbKh4qSdCI+6tpWqB4GKRbpBAFWKgQKVExothdoKOnSMeaIl1rirR3FujsytPd3UZ7R54oFxKGShgGhEGAaGajSZLE3L8qIr9VKBSeWPTzxuXz7bt2WN4/KAGvMFv5QOLimqjzY6vpHe8d/7cPz1d6cFy+zB/nhgsj66WjfombvB7sSoTTHdoccqCBKprN+E4EaoKWgcPAfR7LPaHaj4aGNh+6iZvi5R5N2UspHOiiK/bgPAmT1xH6NaDb3azTIadTH2ADYhNq6kzg+jxwr6h/S8ejB4bKfUcXo258dm3pqsD9RgLditicDnmeLEMEPqHmLj927Nb3D+5quUxNiZJu7wy3h1HyT0w4FywRD76XH7TPvYtdC57PtmiCcXcBzqxWq3+oqr8SBEG+IV1MH11J5bJm0pnNP2U2MpmLZJqP3ZyxIyM8/bX9HP72U5QHJ6jHCRYqUozwfIDkQ4JCiBZDJB+ixYigGBG25YjaIqK2HFExItcWUejIk2/PUWjLkcuHaKBooASNvUq2T49Vp+ZONZ6FmZEkyZCZfaZYLO4WkSVNVCtR0q10FAtdY4tWheYbQAmgLlXPR231ruMT5cVMOShR0ivpjQbXHs/nylFnEtrpEvmZOOsMOkQswolRHcc4RmzPUo+ebWuPThw+vqayEsTSDMdlD7uifG9bfrwSt4knm4n8bFfWC9aNELprXbBRjGPmPKMRz9WPdwyfwVh1KdMw7uY/509wvDPsyEs4Vl02abTSfrLWBVAYr/nEWirvH9w1Otcz7ac/iDqfWFM2DwHaC+HEYo3CS5VgNlSr1d9TkZs0CIqTkdszEmn+Pdc2rUGniNlyqgmNbk5ttEp9rDpVt5CqRE3TvUVl6lizazTSsnMaaSJMkgdwEpHMtplZY3vc3f9doVC4TWTlo9q9XNEY6j0I4TrQITom/3kFAusgtDE2xjOHiF9M7KUUztY+GE72QfyzNh/opcRSV5wbUfd7XeQ97j65fOhMm0mzMfZUsW/n8m+ZGYKhOW8SArnOPLnO1h94z7yLJ+PZNf9uqm/WGDKnGBKfSZCe4ilV/dH/zuQCZNGCiDmFd+tLiUwiedm272cNS9XhqwTBT4FH3D2e1S+lRayW2SQSaD3/aCHu/9MD0kxtDSKZRijzIJf5SCstiKUhvQ2JyAO5XO6Z2Ru8ilX848SSCEZELIqi54FvuvtEc8ecSSbSIm3m72bMRjLNeXOpXPPNb1X3Ep7HNOnN0z8HgW8xR8ySVaziHyuWYxRiyMy+4e7PmJk1SzHTpJQ5SAbmlmRmEsFsJNFcplU9s50zF7ksUXopO9yXz+d/uJTh6VWs4mcVSyYYEbFCofAk8FV3H50pxZxEMi2kl1OpS8375vT5bs3lW9XRqv6Z7ZsmiTW2WSSxSekFHnf3r0HrNXhWsYp/7FiqkbeBIeBu4Gozu1REguahWmgy0KYHJxlrYYYj3Yz0ZrQ6byFopRrNxKxqXEaUSGvpq0l6GXX377v795dZemnMazBO9qpt5r+kxTnO9KVTWtXVXNab8ht5zLOORrpkea3aC+nMi+Z/aKMsM873Gef4jHLa4vyQ9Dn4jPyZ12/UJbRexa1h9NWm/GRGXWF2vjddczp29gectaaAtinFep3d11SZHC1z4aNfzlHsylGOhNDqdF1Vbb2Wlgul+4sMjE4XEOLOKp++bMof52M/KNIVCbsvmzjp/I/9sEBuLMdomDAwUObCPmGAAn3XTEy7ZmlfjvHnIz715gkWMbK3bGPv7r6+Wq3+c1X9Z6q6rjFk3VKiaHK+a1WmkTZro0+hWs3Rxpa/W9U/c0i6OX0uFSnze3E3+5Go7s7lcl8VkeWaUqJAD9AFHIeTgi21k0a2qwJHmeoAXUAfqTfuQFN6d7YNZ5sCa4DO7Fiy3ydIbUhrs3MHmep0bVn6OOmHRoFC1s41pB1yoqm9zc8iBDZl7Wt0zLGsbCVLX5tdr3Gvmp2TZOU8u9ZaIJe1+wipG/zp2bM4Tuql25nV1bwsXF9W51B2/qZs33hBEuD5rD1rsuvks3YeztILWT2d2XnHsm2qo+7sDzizbzviFyOyCeMEot+m/eqnARj//jo8OR9JtoN3Iz5IIg9QrzzKH79t+goCH707T6H4ZpCmYFmWIP4T6m3/wB+9upyWKbweZx3k/45PveZoWs6Fj31zM4FehnA6WJWEhzE/TBRcjiX/wDOD+9lzQ0JpX46JY1dC0onJvXRcM7jQxQOXS4IBOB4EwV3ufpmZvRHIN3fOZjjTPW9nI4nZSGCuYe65MJ+y8yWXVuUbfi/uPuDw5Xwu98NlJBdIO+t64HzS4En7mOroAWmHugB4hrRTGen/+DRgB2lHGSftHELaWc4EDpJ24LXAeaSdc5C005yZXWsI2ELaUfcBh0j/le1ZmSOkRNQNnJudO0E6c3xztj1KSnwNRE11DmXH5wHPZmW7gW3AE0wnmNOz+x7LypyfpddICSIkDZF5TlZmlJQcXpGlPwI0wk9uICWMMilZnpvVPZHdX52ULDqyZ9t8nQB4LmvzelIyC4DerI6pKHSbNp+G1v8FsB6zAUQ2IbaGE9+8A4mUIP5VlGvAhzEZArka8RvI5/87pb1fZve1TYMEvXkYeyfIFlwOIFRAYswPEeuj4BUK3z4TTz6Es52gNkFp71fYfW2F3/3uGhI+gNsVIAOY5FEuIgi/APZ6VC/mjI1/SsmfZ+wb21D9MC6PIbn7FrMy6bIRjIgk7v5wvV6/A9jq7ue6u8y0TcxmZ5mpZjSfMxtms5vMlT9H++e0DTWPhLWyGTVJYDV3/04QBHtIO81KoABsJO2sh0jJooeUSIpMVzs6SDtXnSlpozGvSEnfASXtqFuz8w5mZdY35ZPV25eVqzAlsTSWIc+Tduou4GHSL7yRSgQhaadthmTpR0k7PaRk0UUqDTTaN/OlCZkizw2kUsY+UoLLMUUezecGWd7ZpCR7IHsmzffXUMmeJiW5hqpTAy4iJcB9pMTRuE5ASp5HgMeYUrWm32uufhH4FsxvI9C9xEkbaidYc9oJxo9+AOENuNxJIF/FcxMk1T5C/TXcb2TMn2Fn/0/Y0xT/xqUN/BGM/0HiaVziNd2jfOqyCW66L8Liy4AeREYxrmA4+HtKfoSJvWtxrgC9nyTZQxLUyNUjxuUQbZyG+PUE9asY/s53CYLrcC8g+n3aaosK2bncc1nGkyS5x8zuNLOh5vlGs3XgU3Xs2aSg2TAvP5kZmC+5zLS7zCTPTHrZ5+63R1H0xAqNHDlT6/mcRvqi50gJJ8+U2tBADykhHST9wq5j+odFSTv0VlJyOtiijgZqWV4baUctzsjvYkp9O0TayaqkZDWc/Z7rvhp2mxqzzPRtcU7MlEqWy64527kjWf4ZpM+r1fvfsMc0tlrTdaLsOnmmpDPL8jpJidyzvBlfey/jhIhup26bkWCQ9jcfY3CwG7HX4v4E6Nf45DVP86nXHKVL9mP8Dc5mVLbRc04Lz1E3VBJCTcjnJyZtLWvLHQg/D/oocBf4hQR+Og/vEWqSIFLD/UxEzkKtTtz5HH9yzTiJfQfkKZA3EcbXov5qnO8R6E/Zfe2inA+XlWBExAuFwgtBEHzB3b/t7uX5kIxmWyNdVU9STxZKNPNo67R65yS89GBOu0s6Qu/Pu/tfFovFr4vISq6817CltJN2lJ5sG4Jpi53ls/SGHWGEVKLpZurL3kaqhmwi/TLPFVLCSKWN55lSr5rj0uRI36lG54O086/JrjlbAPDNwKXAZaQS0gmm20lmQ0Kq8oyQEuRVpOpK+yzl66QEWiFVzVotWxKSkuelwKuYUrkOkRLnWcAVpOpSJym5HCCVZC7K7uF0ZhqLI3sQYS/iryKUf4v6bzO69yLCuBuXHkQPkuSGJw2pu6+NCeLHspgz6yiOTn92QoDoK3H/TcQ+jtd28nvf6WNnf0AtPi9tpz2A23cQBEl+jo1ntRPVBzC/C6UX4aOE+nHC8rV87IcFxruPIv4VjHW4fxgYBruH/GsXPX9u2WfjikgShuE/iMj/crMHzazeHLah5ejMjM7eyJuNaGaSwjzb1ZJUmvNmnWM0Bwk12V1G3P2LInIbK79iYEIqkpdJVZIzSTv/C0wnh0bHbnx9jVTqaBg2ISWCY1ldPaSdZq6HWmfKxnMaKcE1OlPzKFIDG0g76tWkkkMrjJJ24OdIiaUva/dsaK5/EHgQeICUaLaRkkArMnNSAj7AlP2nbUYZy8ocyrbRprSHgB+T3vs52fkRqUr1Y2A/KRldQvMKCAC5Nw7h8f8gkX+P+1eBKwn4CGqb0yVOPUdhfPpzt1wWVImYQjxjaBUHP4xyP6rfQ+RhcsVxTj8jh/jrEMmjBCBrMB9GuIri+Cba31wmyN9JEnwC5K9x7wV+k7ByHkMHjHrbg4g8hLAB4y46ggOLsb00sJxG3kmISNXdv1WpVHrV/V+6+4XuHs0khGm2Fkhju8yS3zDoNht4F9imlsezGW1nSi3T8k5Wi8bd/UtBEPz3KIqeWSHVaCYaoxiXkEolj5F2gj6mbBu9pKRRJo1YL0yNND2b1VMnlUjKpF//raSkM9dyIBXSTlogJbc4q6MhuXRl1xljagRmB7O/byNZucbQ71lZHdWszQ27kmfXzGV1NqKXVkgJdzzLKzBdsmpGYxSsAGwnJbLnZuQfn9Eey+qrkUqOJ7L7K2b1TJAS0XhW5tIsvTFsDQP3tEE0Qdz5EPnykxTqa8G3oKFD8jTCDmI5i5vuG2HTqFOOiiTVqxBqIM9R2DxzTSQDDpHYd6l3HiY/nPDwgSpnbNyM+OtwyeG8ASUB6UlVIr2A8vdeoB5EjBf203viGeJgBPwm3NeysSMkHhpHcwdB64Tsn25cXjhWhGAARGTE3e+qVqsdZnYTcJ6q5po7aWOm9WQHF4HMV2a2HtogmgbmGoWaed7M362IBZgXuTTNEp9w96+6+3+LouhhWd5Ro9nQeAADwJOkL/+hGfntpORyGPgpU8bHM0mlisYXtmFDOJLVs5VURdg/41rNdTfsQAdJJZ7GMPNIVs9ZpJ33WVIC6yCLkz7L/eSYkpx6SUmjStqRh0lVqDopYW0k7dhPZ20/Oys/lKU3yCeecT1vOm4QYkf2jJrJSJgyjDfIZZxU7cmRklNASiDDWdoZWZnGaFWdKdsNlFwZu+c14OeiI/sxmQA/A3SI2A6hfhcqN4N8kK7RrzPux7DK2ajsBHkI9GF2XzjTrmRADxpsJz/eQ1JwNvcdReJLEYlw/hsaPoATE9CBJR/HuAKpDRFyKV0TB6kFAyS+lYgJxE9weCxmY0eIaB3xhLovOaTmihFMhmP5fP4L1WrV3P2DZnaeiLRrGgNVMpzsWEcqzYhIyzeyWYKYSS4zPYlbnTfzuBWxzMxvIhfP7C2JmQ25+9fd/ZZCoXC/iLwY0drrpNJGku0fZ6pDtpF2rsZXv6FKNatsR7Jybdk5DaNoTEpSOVIpqDHU2si3rO5GxzGmCO60rExCSipGSgoXMzXaM0bzsG2KRuftJbVfNIy8z2Z110mHqM9hcvF6JMs/xNQoz0ZS4lRSkmv4p4xn99gYbm5IPWTpB7LnFGfpjWe7KXsGjRGkxuhQX3ZfQVauYchuqFsNR71naPbe3o3z2z6Gs+3/b+9MYuw4yjj++6q63zZ+9ozX8ZJF2bAMVlAigRQrKBJICRJcEM4JhMQhdyQ4WzmCBBduuaHcEoG4BUTAZpFAkJANW0FK4sTb2E48nuW9fu/1Uh+H7p7X09NvZryMTeT+S+Xuru6u7vZ0/95XX31VBRwDtTgBw6/Zvvccg+tX0KiJ029i3A9QUcR4wFmQl/nkyrlVQW5J4BAuofJF0O8hJJg4xrq/ImYfyptY+Setr2UdbE816PNHRA+TSBeruxF5EnEGIw6V3xHJR1nsi6V/dRH0w3wKmlvR7fOaTpCmA1PtSJLkK86550TkCRGZxemOZBDuQsTHM4g16Xgs4/NWgvJg/NOzmUC89bTGahlvVIJFXTYlSeLU+LYnRhZVdUFV33fO/UlETjYajbNb7NRduUvG5n+ftc7Y/JfVZPt80o9qVDom9zvEpI7gIePOmA1S6ycHRh4jEpN+jC7b1sLxLdIPMYdbfh9tUrhEjD/2Yn0+b8HK/SWalREUni0P3JvKyhqSwipiXBVsF+6tV3iW6ey+Btlz+FnZ+YeTVxk1O8Zn3DyeyzGuLuZVIkihPcjKaGb/p43sGZcpt2T96O9t3HAfTbsX1SZwmcWpj9PI2ywyd2F5L77uQ6WNcUs4c46fP3ONcgTt8Vcsh3YfRryxn8qoApexSQekT4sL45YfFX78hz0k3h6a/iVcnDYOJK6DsMBo28f88qtLq47V5gOE/XfXBPndoLYcMLlU1SOLphwsLx9YfPviU8sfXP2ua5gvNfZt77Znp6U1PYXxU9gYaxEr2SBQubO1YL2sLnvda6+xXLLzU4BlS5f5VBKXAUUZBSOWLy8RfLo8Muh7ex478JudD+/+h7X2POkv1AgI7lC1qOoRJu0rqtIIrMjTTeyXimOZkC+l/PXud6PjNjom31/eV+zysJl7L16nqGJXCSnlFa+13jOkVSXOeMwNlJeejNeAI98PcOZ0siruZU1ZJz3muqvv9fpHjiN7BJ5xax2zKpw4ZXnxmbTMF9702N+WytipnzMAAAe3SURBVOucUMPcm3ZVt4Ob1B0DTPGaJ0+etJ33Bp3wV+880e8tf7+vfH2xpbPsnmq2D07TPTDNttlppnZ3ac9M0dreobGtSWNbC7/VyAbtzqFT8N9M+ixUU0MoW7rEEQ4jRr0ho/6I4fKQwWJAb77P0tUlFi8vsTS3SPhZz3VCe7Xtea/tmN3+8qM/PPJ2+wuzwVtvvRU///zzk/rW1Kq1hVLhBMKZV9O3feYhw/41k0zA3EC5/lEKmSPHlRfzd/XO9uq/U4Cpuo6c4Ij3ZY49KE3v2aHod/q+HA08nY6bnlXfYpsettPEa/vYlodt+nhtH7/bwp9q0phq4rUbeA0P2/QQm00xQlqzclFCPIpJooRREBIGIWEwIgxC4mFCNIqJw3QZDSOiMMYlisROm4nttxPe8R2vOEl+f10Xzr8499KQaqjUoKl1G5TN3338VcPMQ4apyMNPPEaRxbQMrb4QWx81bdQ1UW1iaKHSRvAwpJ38jAhqQoj7qAkxGpHokLAR4Hk9tg8jznyavrNHjmdxN+hWwGerAVMuv2pbfsHx7Ye86aOi5lsjy7OB1fsGRruRtVaNgBTiUEwal4IRsFmMjJH0TyOpBZv+mQRFVyZ5cJk7J5+FMU1pfpKNa2cVGir9lsjZBvL6SKPfXrl8+fQZ/rX8Gh+UWyWo2J6UV6tWhVQ4carJwPeJrI91HiZs4JhGdAeOfRgOgh4A6QJtnPoY6eC0k+WlzeUGm0/7ks0kOHZyOw0xskTMh4j8G2POpfDRGGsSnA1J4hBjRsTEuI5jp42hHaetVzcPnq0CzKbAUkjmCHu8b/P4zsN2/+NN23nOGZ4ODAeHIlORaCPJ53XNICJSOH2lmTv9R7PWp3Q+6RQ4jnQ2qXEcuK7clVUTezDsYM+L6OtBMnjtUnTpzH8WPlz8M+/kjkktpHL9ezPgqXWv68RJD7oN5hMPwia+tjDxoyiHETkErotKF5jFsA+YxtGEwpxnRhSngsk++lXr+XunLsvLpvJQRcQhhDh6wABDDwhBR0AfpYfIEuhyus4V1LuAkwt4ZoGfHevdDGhuN2Aqq0Kl9bwp0hS2885yZi9Tjad4ZMfj9r4HD3ozTzdN+5gT81gg0o2FZmSc5xDjTDbcf8Fiya+gIikRCg5hl8EmbWjGWUg8K5GvdsEK7w8Z/uV89OnfPlg+d/GT8MLSfzk/YHWflBwyZdiUYy1YZ7vWvaoX3vCZGe4nCR/B6f0YOYxwCEcbQyet2rAAEqE0QNMoXmGISpD2ZTIDjA5QhqADRAKQENUAzVrGRBKEEc4lWGKc2tTkz6Tio/igBmOaqBNULUbaIG0ibeLRBAkRdw2VAOEiJnmbn35j6UYhczsBs57VUgRLeWkZA8bL1j3AO8Ke7lF7/96HvNmH93ozR9vSOGzUOxgbuytGW06Ml4gzCWISMeIAkRQ3iRjNL2tFFWMTX0mMMMDofOyi8wMZnb7qFt49F8x9cjG8Nn86PrsUEo4Yj3yfR3IWIzonwSZXDZlaJanwk1P7cDyC0MLRw7gg9ZMAzvj4SUjsBXiJElvBN0LkFM8kuCDGNwmBTXAdRztSepGyp5tZ0stji3p+oOx8IH3n5ga6xgE8/4mwM8/LZqftzwumYxj4ggkMnSTt+tHrpq1IIxvz0pODu23BTAJMFVzyZEvJKyQ/WzZaeK3ddLcd8Gd23iczs7u87Qdm/OmDXWnOetLc5cXSxRpfxXiJqhEx4owmBpLYMUps3Bsa91kv6s0taHBxPlm6fCVauHJ1OH/9Ggu9HsMBabxEyBgsMatBk6dJkKFiyYTtWveaXnjDZyryiK87Rntd2qR8XFdag1a19FTp8zmm8+0CzEbWS7FKVAbMKqulkBqkkGkUUstA28fvbMObMnhTnvU627xWp91od1piWpL4DQSiRhyGiQxHw+VgKRwGTlwQuThIiIMhURDhAsZBaPnwAPkyB0u+nrAWMmN3zsbVpc/ly1Gr1q1qq7sKwFrYTNKkPi95Xxkh3UhGROGIqA/4JHgk+IzwDVg/ndWeiHS+Y5eDQonS7JVUtFaqxoytW4hq1bpFbQVgqiJJi1GWxfXcv5HLlM4vHpOnmBQOueWz4sNxYEY4KZ1bdX5VNaicJlktxWrQJGdvrVq12BrAFMOy8+384yuOAu8qjslhkI8Gn0Mgh0nIWr9NscpVFVJe9JmUoVEGT5XvZbPO3Vq1apV0uwBThkrV/lz5x1nsu5F/vHknvZi1ICnDpLhdjqvJyy3HrhRBUwROGT7FY7S0rGqmrp26tWpVaKt8MFVWTHl/8bi82pSPWZKwGiZVqdw6VWy1ysuelMpWSQ6NhGqQTILKZuBSw6bWPautDrSbFHhXtjbKeVUxM+X1qlTWev6SMjg2gkgVVGq41Kq1ju5mV4F8WQWaqn1VlkrZapmkjRyzG63XYKlV6ya0VYBZr+wbgU3V/nIZm32GqiboquVG65PKXC+vVq17UlsJmI2us17eZpfrlVXWeoDJ1yeBZ1I56+XVqnXP604BZjPX3Ez+RpZLVQxOlTaCzXrHbya/Vq1a3B3AbOb6m72vG7n/G4HBzcCmVq1aJd1twFRpK+BS1mYhUcOkVq1b0P8jYDbS7bznGiC1atWqVavW51H/AyaNHWfMog9EAAAAAElFTkSuQmCC"
                        style="width: 159.50px; height: 58.67px; margin-left: 0.00px; margin-top: -2.22px; transform: rotate(0.00rad) translateZ(0px); -webkit-transform: rotate(0.00rad) translateZ(0px);"
                        title="">
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text
                        @click="showTermsDialog = false; registersupplier.acceptterms = true">Acceptera</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
export default {
    name: 'registerComponent',
    data: () => ({
        valid: false,
        loading: false,
        showDoneDialog: false,
        showTermsDialog: false,
        error: '',
        mode: 'login',
        login: {
            login: '',
            password: ''
        },
        registersupplier: {
            orgnr: '',
            name: '',
            mail: '',
            acceptterms: false
        },
        emailRules: [],
        requiredRules: [],
        orgNrRules: [],
        resetDialog: {
            show: false,
            mail: ''
        }
    }),
    mounted() {
        this.emailRules = [
            v => /.+@.+\..+/.test(v) || this.$translate('Invalid email address'),
            v => v ? true : this.$translate('Value is required')
        ];
        this.requiredRules = [v => v ? true : this.$translate('Value is required')];
        this.orgNrRules = [
            v => v && v.replace('-', '').length == 10,
            v => v ? true : this.$translate('Value is required')
        ];
    },
    methods: {
        callLogin() {
            this.loading = true;
            fetch('/api/v8.0/memberapi/login', { method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(this.login) }).then(response => {
                this.loading = false;
                if (response.status == 200) {
                    this.$refs.loginform.reset();
                    this.$root.refetchDeveloper();
                    this.$router.push({ name: 'list' });
                } else {
                    response.json().then(error => this.error = error && error.message);
                }
            });
        },
        callRegisterSupplier() {
            this.loading = true;
            fetch('/api/addon/supplier/supplier/add', { method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(this.registersupplier) }).then(response => {
                this.loading = false;
                if (response.status == 200) {
                    this.$refs.registerform.reset();
                    this.showDoneDialog = true;
                } else {
                    response.json().then(error => this.error = error && error.message);
                }
            });
        },
        sendResetLink() {
            fetch('/api/memberapi/requestResetPassword?mail=' + encodeURIComponent(this.resetDialog.mail), { method: 'POST' }).then(response => {
                this.resetDialog.show = false;
                if (!response.ok) {
                    response.json().then(error => this.error = error && error.message);
                }
            });
        }
    }
}
</script>
